<template>
  <div class="switch-loyalty-system-settings">
    <div class="switch-loyalty-system-settings__option loyalty-system-card">
      <div
        class="loyalty-system-card__header"
        :class="{ 'is-active': value === bonusMode }"
      >
        <label
          class="loyalty-system-card__radio-control radio-field"
          :class="{ disabled: disabled }"
        >
          <input
            type="radio"
            name="loyaltyType"
            class="radio-field__input"
            v-bind:disabled="disabled"
            v-bind:value="bonusMode"
            v-bind:checked="value === bonusMode"
            v-on:change="onModeChange(bonusMode)"
          />
          <h2 class="radio-field__text">Бонусы за визиты</h2>
        </label>
        <p class="loyalty-system-card__description">
          Пациенты копят бонусы и оплачивают ими услуги
        </p>
      </div>
      <div class="loyalty-system-card__body">
        <section>
          <h3>Как работает</h3>
          <ul class="loyalty-system-card__how-it-works">
            <li>1 бонус = 1 ₸</li>
            <li>Бонусы начисляются за каждую оплаченную услугу</li>
            <li>Бонусами можно оплатить часть следующего визита</li>
          </ul>
        </section>
        <section>
          <h3>Преимущества</h3>
          <ul class="loyalty-system-card__advantages">
            <li>Пациент сразу видит выгоду</li>
            <li>Повышает частоту повторных визитов</li>
            <li>Хорошо подходит для стимулирования возвратов</li>
          </ul>
        </section>
        <button
          v-if="value === bonusMode"
          type="button"
          class="loyalty-system-card__edit-button"
          v-on:click="$emit('edit-bonus')"
        >{{ getTextEditButton }}</button>
      </div>
    </div>
    <div class="switch-loyalty-system-settings__option loyalty-system-card">
      <div
        class="loyalty-system-card__header"
        :class="{ 'is-active': value === discountMode }"
      >
        <label
          class="loyalty-system-card__radio-control radio-field"
          :class="{ disabled: disabled }"
        >
          <input
            type="radio"
            name="loyaltyType"
            class="radio-field__input"
            v-bind:disabled="disabled"
            v-bind:value="discountMode"
            v-bind:checked="value === discountMode"
            v-on:change="onModeChange(discountMode)"
          />
          <h2 class="radio-field__text">
            Персональная скидка пациента
          </h2>
        </label>
        <p class="loyalty-system-card__description">
          Скидка растет по мере увеличения общей суммы оплат
        </p>
      </div>
      <div class="loyalty-system-card__body">
        <section>
          <h3>Как работает</h3>
          <ul class="loyalty-system-card__how-it-works">
            <li>Скидка действует на все услуги</li>
            <li>Размер скидки увеличивается с ростом общей суммы оплат</li>
            <li>Скидка применяется автоматически</li>
          </ul>
        </section>
        <section>
          <h3>Преимущества</h3>
          <ul class="loyalty-system-card__advantages">
            <li>Формирует долгосрочную лояльность</li>
            <li>Особенно выгодна для постоянных клиентов</li>
            <li>Простая и понятная система</li>
          </ul>
        </section>
        <button
          v-if="value === discountMode"
          type="button"
          class="loyalty-system-card__edit-button"
          v-on:click="$emit('edit-discount')"
        >{{ getTextEditButton }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  LOYALTY_MODE_BONUS,
  LOYALTY_MODE_DISCOUNT,
} from '@/mixins/loyaltySystemMixin';

export default {
  /**
   * @description Переключатель режима работы системы лояльности
   */
  name: 'SwitchLoyaltySystemSettings',
  props: {
    /**
     * @description Значение
     * @type {string}
     */
    value: {
      type: String,
      required: true,
    },
    /**
     * @description Отключен ли компонент
     * @type {Boolean}
     */
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      bonusMode: LOYALTY_MODE_BONUS,
      discountMode: LOYALTY_MODE_DISCOUNT,
    };
  },
  computed: {
    getTextEditButton() {
      return !this.disabled ? 'Редактировать условия' : 'Посмотреть условия';
    },
  },
  methods: {
    /**
     * @description Обработать изменение режима лояльности
     * @param {String} mode
     * @returns {void}
     */
    onModeChange(mode) {
      this.$emit('input', mode);
    },
  },
};
</script>

<style scoped lang="scss">
.switch-loyalty-system-settings {
  display: flex;
  flex-wrap: wrap;
  gap: 25px;
}

.loyalty-system-card {
  display: grid;
  grid-template-rows: auto 1fr;
  row-gap: 15px;
  width: min(100%, 555px);
  border-radius: 10px;
  border: 2px solid var(--border-color);
  &__header {
    position: relative;
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    padding-inline: 20px;
    padding-block: 20px 10px;
    border-bottom: 2px solid var(--border-color);
    border-radius: 8px 8px 0 0;
    &.is-active {
      background-color: var(--fill-color);
    }
  }
  &__body {
    display: grid;
    row-gap: 10px;
    height: fit-content;
    padding: 0 20px 20px;
  }
  &__description {
    padding-left: 34px;
  }
  &__advantages {
    li::before {
      width: 14px;
      height: 10px;
      background-image: url("@/assets/img/checked/checked-blue-top.svg");
      background-size: contain;
    }
  }
  &__how-it-works {
    li::before {
      width: 6px;
      height: 6px;
      background-color: var(--action-color);
      border-radius: 50%;
    }
  }
  &__edit-button {
    position: relative;
    display: flex;
    align-items: center;
    column-gap: 5px;
    width: fit-content;
    color: var(--action-color);
    font-size: 14px;
    transition: color 0.3s;
    &::before {
      content: "";
      width: 15px;
      height: 15px;
      background: no-repeat url("@/assets/img/pen-grey.svg");
      background-size: contain;
    }
    &:hover {
      color: #0076C4;
      &::before {
        background-image: url("@/assets/img/pen-blue.svg");
      }
    }
  }
  h3 {
    margin-bottom: 5px;
  }
  ul {
    display: flex;
    flex-direction: column;
    row-gap: 5px;
    padding: 0;
    list-style: none;
    li {
      display: flex;
      align-items: center;
      column-gap: 10px;
      &::before {
        content: '';
        flex-shrink: 0;
      }
    }
  }
}

.radio-field {
  display: flex;
  align-items: center;
  gap: 10px;
  &:not(.disabled) {
    cursor: pointer;
  }
  &__input {
    position: relative;
    flex-shrink: 0;
    width: 1.5rem;
    height: 1.5rem;
    background: var(--primary-background-color);
    border: 1px solid  var(--unfocus-color);
    border-radius: 15px;
    -webkit-appearance: none;
    appearance: none;
    cursor: pointer;
    &:checked {
      border-color: var(--action-color);
      &:disabled {
        cursor: not-allowed;
        border-color: var(--disabled-backgroud-color);
      }
    }
    &:checked::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: var(--action-color);
      transform: translate(-50%, -50%);
    }
    &:disabled {
      cursor: not-allowed;
      &:checked {
        border-color: var(--disabled-border-color);
      }
      &:checked::after {
        background-color: var(--disabled-backgroud-color);
      }
    }
    &:hover:not(:disabled) {
      border-color: var(--action-color);
    }
  }
  &__text {
    font-size: 16px;
    color: var(--reading-color);
  }
}
</style>
